// src/components/Hero.jsx
import React from "react";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section className="hero">

      {/* 🔥 Background video */}
      <video
        className="hero-bg-video"
        src="/media/hero-bg-boomerang.mp4"
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Fallback image (for browsers that block autoplay) */}
      <img src="/media/hero-bg.png" alt="" className="hero-bg-fallback" />

      <div className="hero-content">
        <img src="/media/logo.png" className="hero-logo" alt="Namaste Logo" />

        <h1 className="hero-title">Namaste Restaurant & Bar</h1>

        <p className="hero-subtitle">
          Flavours of India & Nepal — Served With Love
        </p>

        <Link to="/order">
          <button className="hero-btn">Order Online</button>
        </Link>
      </div>
    </section>
  );
}

export default Hero;
